<!-- Admin Notes inline-edit template -->
<ng-template #adminNotesTemplate let-row let-value="value">
  @if (editingNotesId() === row.id) {
    <input
      class="inline-edit-input"
      [id]="'notes-' + row.id"
      [value]="notesEditValue()"
      (input)="notesEditValue.set($any($event.target).value)"
      (blur)="saveAdminNotes(row)"
      (keyup.enter)="$any($event.target).blur()"
      (keyup.escape)="cancelNotesEdit(); $any($event.target).blur()"
      (click)="$event.stopPropagation()"
    />
  } @else {
    <span
      class="editable-cell"
      (click)="startEditNotes(row, $event)"
      title="{{ value || 'Click to add admin notes' }}"
    >{{ value || '—' }}</span>
  }
</ng-template>

<!-- Remarks inline-edit template -->
<ng-template #orderRemarksTemplate let-row let-value="value">
  @if (editingRemarksId() === row.id) {
    <input
      class="inline-edit-input"
      [id]="'remark-' + row.id"
      [value]="remarkEditValue()"
      (input)="remarkEditValue.set($any($event.target).value)"
      (blur)="saveOrderRemarks(row)"
      (keyup.enter)="$any($event.target).blur()"
      (keyup.escape)="cancelRemarkEdit(); $any($event.target).blur()"
      (click)="$event.stopPropagation()"
    />
  } @else {
    <span
      class="editable-cell"
      (click)="startEditRemark(row, $event)"
      title="{{ value || 'Click to add remark' }}"
    >{{ value || '—' }}</span>
  }
</ng-template>

<div class="main-content">
  <div class="header-actions">
    <h4 class="card-title">Orders List</h4>
    <span class="header-buttons">
      <!-- Labels for every Singapore and US order on this page. -->
      <button
        mat-stroked-button
        [disabled]="!pageSgOrderIds().length"
        (click)="printLabels(pageSgOrderIds())"
      >
        <mat-icon>print</mat-icon>
        Print labels ({{ pageSgOrderIds().length }})
      </button>
      <fh-refresh-button [refresh]="refreshData" />
    </span>
  </div>

  <!-- showResetButton=false: Reset button injected inline beside the search field (slot 3) -->
  <fh-filter-bar [showResetButton]="false">
    <fh-form-autocomplete
      [options]="countryOptions()"
      [label]="'Country'"
      [placeholder]="'Select country...'"
      [showCounts]="true"
      appearance="outline"
      [formControl]="countryFilterFormControl"
      (selectionChange)="onCountryChange($any($event))"
    />

    <fh-form-autocomplete
      [options]="filterOptions"
      [label]="'Filter By'"
      appearance="outline"
      [formControl]="filterTypeFilterFormControl"
      (selectionChange)="onFilterTypeChange($any($event))"
    />

    <!-- Slot 3: search field + reset button in a flex row -->
    <div class="search-reset-slot">
      @if (filterType() !== "orderStatus") {
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search Term</mat-label>
          <input
            matInput
            [formControl]="searchControl"
            (keyup.enter)="onSearch()"
            placeholder="Type to search..."
          />
          <button matSuffix mat-icon-button (click)="onSearch()">
            <mat-icon>search</mat-icon>
          </button>
          @if (searchTerm()) {
            <button
              matSuffix
              mat-icon-button
              (click)="searchControl.setValue(''); onSearch()"
              class="clear-button"
            >
              <mat-icon>clear</mat-icon>
            </button>
          }
        </mat-form-field>
      } @else {
        <fh-form-autocomplete
          [options]="orderStatusOptions"
          [label]="'Order Status'"
          appearance="outline"
          [formControl]="orderStatusFilterFormControl"
          (selectionChange)="onOrderStatusChange($any($event))"
        />
      }

      <button mat-stroked-button (click)="onResetFilters()" class="reset-btn">
        <mat-icon>refresh</mat-icon>
        Reset Filters
      </button>
    </div>
  </fh-filter-bar>

  <fh-data-table
    [config]="tableConfig()"
    [sortProp]="sortProp()"
    [sortDir]="sortDir()"
    [pageIndex]="pageIndex()"
    [pageSize]="pageSize()"
    [actions]="tableActions()"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
  />
</div>
